import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment, Dropdown, Form, Button
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

export default class AddExistingQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            question: 1
        };

        this.fetchDefaultQuestions = this.fetchDefaultQuestions.bind(this);
        this.addQuestion = this.addQuestion.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    componentDidMount() {
        this.fetchDefaultQuestions();
    }


    fetchDefaultQuestions() {
        axios.get('/question/default/')
            .then(res => {
                const defaultQuestionOptions = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.text
                }));
                this.setState({ defaultQuestionOptions });
            })
            .catch(err => {
                console.log('Failed to fetch poll defaultQuestionOptions.');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    addQuestion() {
        let obj = {
            questions: this.state.questions.map((e) => ({ id: e })),
            questionnaire: { id: JSON.parse(localStorage.getItem('poll')).pollId }
        };
        axios.post('/question/connect-existing/', { ...obj })
            .then(res => {
                toast('Uspješno ste dodali pitanje.');
                this.resetForm();
            })
            .catch(err => {
                toast('Došlo je do greške.');
                console.log('Failed to create question.');
            });
    }
    resetForm() {
        this.setState({
            questions: null
        });
    }


    render() {
        return (

            <Fragment>

                <Form>
                    <Form.Field width={4}>
                        <label>
                            Pitanja
                        </label>
                        <Form.Dropdown
                            clearable
                            multiple
                            placeholder="Odaberite pitanja"
                            value={this.state.questions}
                            onChange={this.handleInputChange}
                            name="questions"
                            options={this.state.defaultQuestionOptions}
                            search
                            selection
                            required
                            error={this.state.questionsErr}
                        />
                    </Form.Field>
                    <Button
                        onClick={this.resetForm}
                        floated="right"
                        color="blue"
                        basic
                    >
                        {<FormattedMessage id="poll.cancel" />}
                    </Button>
                    <Button
                        onClick={this.addQuestion}
                        floated="right"
                        color="blue"
                        primary
                    >
                        {<FormattedMessage id="poll.addQuestionButton" />}
                    </Button>
                </Form>


                <ToastContainer hideProgressBar />
            </Fragment>


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/CreateQuestion/AddExistingQuestion.js